import React from 'react';
import { Box, Button, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  categoryMenu: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(1, 2),
    borderBottom: `1px solid ${theme.palette.divider}`,
    position: 'sticky',
    top: theme.spacing(8),
    zIndex: 100,
    overflowX: 'auto',
  },
  categoryButton: {
    fontWeight: 'bold',
    fontSize: '1rem',
    textTransform: 'none',
    padding: theme.spacing(1, 2),
    color: theme.palette.text.primary,
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    }
  },
}));

interface LocationInfo {
  google_font_family?: string;
  ordering_system_primary_color?: string;
  ordering_system_secondary_color?: string;
}

interface CategoriesProps {
  categories: any[];
  selectedCategory: string;
  onCategorySelect: (id: string) => void;
  menuData?: {
    location_info?: LocationInfo;
  };
}

const Categories: React.FC<CategoriesProps> = ({ categories, selectedCategory, onCategorySelect, menuData }) => {
  const classes = useStyles();

  return (
    <Box className={classes.categoryMenu}>
      {categories.map((category) => (
        <Button
          key={category.id}
          className={`${classes.categoryButton} ${selectedCategory === category.id ? 'active' : ''}`}
          onClick={() => onCategorySelect(category.id)}
          style={{
            ...(selectedCategory === category.id
              ? {
                  backgroundColor: menuData?.location_info?.ordering_system_primary_color || '#000',
                  color: menuData?.location_info?.ordering_system_secondary_color || '#fff',
                }
              : {}),
          }}>
          {category.name}
        </Button>
      ))}
    </Box>
  );
};

export default Categories;
